// extracted by mini-css-extract-plugin
export default {"resultsContainer":"SearchResults_resultsContainer__oe4xb","resultItem":"SearchResults_resultItem__tUzc4"};